export const USER_LOGIN = 'USER_LOGIN'; 
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_SET_TOKEN = 'USER_SET_TOKEN';
export const USER_GET_INFO = 'USER_GET_INFO';